import { type WorkspaceInfo } from '@air/api/types';

const messageTypes = ['welcome', 'open-asset', 'open-board'] as const;

export type WebPageSocketMessageType = (typeof messageTypes)[number];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BaseWebPageSocketMessage<T = any> = {
  type: WebPageSocketMessageType;
  data: T;
};

export type WebPageWelcomeMessageData = {
  appVersion: string;
  syncedWorkspacesIds: WorkspaceInfo['id'][];
};

export type WebPageWelcomeMessage = {
  type: 'welcome';
} & BaseWebPageSocketMessage<WebPageWelcomeMessageData>;

export type OpenAssetMessage = {
  type: 'open-asset';
} & BaseWebPageSocketMessage<{
  assetId: string;
  boardId?: string;
  /**
   * versionId was confusingly being passed in for assetId in the message
   * In order to maintain backwards compatability while also allowing for the correct value for assetId to sent,
   * we keep the original assetId field while also sending a new asset object
   */
  asset: { id: string };
}>;

export type OpenBoardMessage = {
  type: 'open-board';
} & BaseWebPageSocketMessage<{ boardId: string }>;

export type WebPageSocketMessage = WebPageWelcomeMessage | OpenAssetMessage | OpenBoardMessage;

// These events come from web sockets which could contain anything.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isWebPageSocketMessage = (message: any): message is WebPageSocketMessage =>
  'type' in message && messageTypes.includes(message.type);
